import axios from "axios";
import {
  GET_PRINT_ERRORS,
  GET_PRINT_ERRORS_ERROR,
  PRINT_ERRORS_LOADING,
  RESOLVE_PRINT_ERROR,
  PENDING_PRINT_ERRORS,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
  // No response: the network or the server is down
  if (!err.response) {
    toastr.error("Сервертэй холбогдож чадсангүй");
    return;
  }
  if (
    err.response.status === 401 &&
    err.response.data.msg === "Token is not valid"
  ) {
    window.localStorage.clear("x-auth-token");
    toastr.error("Session expired");
    dispatch(logout());
  }
  const errors = err.response.data.errors;
  if (errors) {
    errors.forEach((error) => toastr.error(error.msg));
  }
};

// Empty filters are left out of the query, so "" means "any"
const paramsOf = ({ status, printerId, startDate, endDate }) => ({
  status: status || undefined,
  printerId: printerId || undefined,
  startDate: startDate || undefined,
  endDate: endDate || undefined,
});

//  Get print errors, newest first (at most 500)
export const getPrintErrors = (filters) => async (dispatch) => {
  try {
    dispatch({ type: PRINT_ERRORS_LOADING });
    const res = await axios.get("/api/printer/errors", {
      params: paramsOf(filters),
    });
    dispatch({
      type: GET_PRINT_ERRORS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({ type: GET_PRINT_ERRORS_ERROR });
    handleError(err, dispatch);
  }
};

//  Count the pending print errors for the sidebar badge. Fails silently: the badge is extra.
export const getPendingPrintErrorCount = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/printer/errors/count", {
      params: { status: "pending" },
    });
    dispatch({
      type: PENDING_PRINT_ERRORS,
      payload: res.data.count || 0,
    });
  } catch (err) {}
};

//  Record the admin's decision. Only marks it in the system; the money is sent by hand.
//  Returns "ok", "conflict" (409: already decided, or the payment was fully refunded
//  elsewhere) or "error", so the dialog knows whether to close.
export const resolvePrintError = (id, body) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `/api/printer/errors/${id}/resolve`,
      JSON.stringify(body),
      config
    );
    dispatch({
      type: RESOLVE_PRINT_ERROR,
      payload: res.data,
    });
    toastr.success("Шийдвэр хадгалагдлаа");
    dispatch(getPendingPrintErrorCount());
    return "ok";
  } catch (err) {
    handleError(err, dispatch);
    if (err.response && err.response.status === 409) {
      dispatch(getPendingPrintErrorCount());
      return "conflict";
    }
    return "error";
  }
};
